export default __webpack_public_path__ + "static/media/com-vogue.cf93cdc0.mp4";